/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AWSCredentials
 */
export interface AWSCredentials {
    /**
     * 
     * @type {string}
     * @memberof AWSCredentials
     */
    key_id: string;
    /**
     * 
     * @type {string}
     * @memberof AWSCredentials
     */
    secret: string;
}

/**
 * Check if a given object implements the AWSCredentials interface.
 */
export function instanceOfAWSCredentials(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "key_id" in value;
    isInstance = isInstance && "secret" in value;

    return isInstance;
}

export function AWSCredentialsFromJSON(json: any): AWSCredentials {
    return AWSCredentialsFromJSONTyped(json, false);
}

export function AWSCredentialsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AWSCredentials {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key_id': json['key_id'],
        'secret': json['secret'],
    };
}

export function AWSCredentialsToJSON(value?: AWSCredentials | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key_id': value.key_id,
        'secret': value.secret,
    };
}

